//App
import { LookupValueApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const lookupValueApi: LookupValueApiType = {
  get: (value) => apiClient.get(endPoints.lookupValue.get(value)),
  getAllByLookupTypeId: (payload) => apiClient.get(endPoints.lookupValue.getAllByLookupTypeId(), payload),
  getLookupValuesView: (payload) => apiClient.get(endPoints.lookupValue.getLookupValuesView(), payload),
  searchLookupValues: (payload) => apiClient.post(endPoints.lookupValue.searchLookupValues(), payload),
  save: (payload) => apiClient.post(endPoints.lookupValue.save(), payload),
  delete: (value) => apiClient.delete(endPoints.lookupValue.delete(value)),
  activate: (value) => apiClient.post(endPoints.lookupValue.activate(value)),
};

export default lookupValueApi;
